import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v1CustomersPlaceAutocomplete } from "@be-miniapp/api"

export const searchAddressQueryKeys = {
  all: ["search-addresses"] as const,
  list: (keyword: string, addressType: string) =>
    [...searchAddressQueryKeys.all, "list", keyword, addressType] as const,
}

interface UseSearchAddressesOptions {
  data: {
    searchKeyword: string
    addressType: string
  }
  enabled: boolean
  /** When true, autocomplete must not inherit the HCM warmup fallback. */
  stripFallbackLocation?: boolean
}

export function useSearchAddresses({
  data: { searchKeyword, addressType },
  enabled,
  stripFallbackLocation = false,
}: UseSearchAddressesOptions) {
  const shouldClearLocation =
    stripFallbackLocation || addressType === "user-location"

  return useQuery({
    queryKey: searchAddressQueryKeys.list(searchKeyword, addressType),
    queryFn: async () => {
      return v1CustomersPlaceAutocomplete(
        {
          text_input: searchKeyword,
          target: addressType,
        },
        shouldClearLocation
      )
    },
    placeholderData: keepPreviousData,
    enabled: enabled,
    staleTime: 0,
    gcTime: 0,
  })
}
